import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapBoxContent: {
    padding: 24,
    boxShadow: '0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)',
    border: `1px solid ${Colors.Grey2}`,
    background: Colors.White,
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
    width: '100%',
  },
  formControlStyle: {
    '&.MuiFormControl-root': {
      marginTop: 16,
    },
  },
  require: {
    marginLeft: 6,
    color: Colors.Red6,
    fontSize: 18,
    fontWeight: 500,
  },
  buttonTwo: {
    '&.MuiButton-root': {
      marginTop: 20,
      background: Colors.White,
      color: Colors.Black,
    },
  },
  linearProgress: {
    '&.MuiLinearProgress-root': {
      width: '100%',
      height: 8,
      borderTopRightRadius: 30,
      borderTopLeftRadius: 30,
    },
  },
}));

export default useStyles;
